<template>
  <span>
    <template v-for="(segment, index) in segments" :key="index">
      <a
        v-if="segment.type === 'link'"
        :href="segment.url"
        target="_blank"
        rel="noopener"
        >{{ segment.text }}</a
      >
      <template v-else>{{ segment.text }}</template>
    </template>
  </span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import useInlineMarkdownLinks from "../../composables/dynamicForm/handlers/useInlineMarkdownLinks/useInlineMarkdownLinks";

const props = defineProps<{
  text?: string | null;
}>();

const { parseInlineMarkdownLinks } = useInlineMarkdownLinks();

const segments = computed(() => parseInlineMarkdownLinks(props.text));
</script>
